import { Municipality } from "./municipality";
import { MunicipalityRepositoryImpl } from "./municipalityRepositoryImpl";
import { MunicipalityService } from "./municipalityService";

/**
 * Controlador de municípios brasileiros via API de localidades do IBGE.
 */
export abstract class MunicipalityController {
  private static readonly service = new MunicipalityService(new MunicipalityRepositoryImpl());

  /**
   * Busca municípios cujo nome contenha o texto informado (insensível a acentos e maiúsculas).
   * @param name Nome ou parte do nome do município
   * @returns Lista de municípios correspondentes
   */
  static async findByName(name: string): Promise<Municipality[]> {
    return await MunicipalityController.service.findByName(name);
  }
}
